"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
function immutableMapToES6Map(immutableMap) {
    const es6Map = new Map();
    const itor = immutableMap.keys();
    let next = itor.next();
    while (!next.done) {
        const k = next.value;
        const v = immutableMap.get(k);
        if (v !== undefined)
            es6Map.set(k, v);
        next = itor.next();
    }
    return es6Map;
}
exports.immutableMapToES6Map = immutableMapToES6Map;
function eS6MapToImmutableMap(es6Map) {
    return immutable_1.Map(es6Map);
}
exports.eS6MapToImmutableMap = eS6MapToImmutableMap;
function immutableSetToES6Set(immutableSet) {
    const es6Set = new Set();
    const itor = immutableSet.values();
    let next = itor.next();
    while (!next.done) {
        const v = next.value;
        es6Set.add(v);
        next = itor.next();
    }
    return es6Set;
}
exports.immutableSetToES6Set = immutableSetToES6Set;
function eS6SetToImmutableSet(es6Set) {
    return immutable_1.Set(es6Set);
}
exports.eS6SetToImmutableSet = eS6SetToImmutableSet;
//# sourceMappingURL=ImmutableUtils.js.map